module.exports = __webpack_public_path__ + "img/Tjkr-ewcvsgBVQIfL85CPSVrbVU.5ff1fded.jpg";